import { api } from './client';

export function getVapidPublicKey() {
  return api<{ publicKey: string | null }>('/push/vapid-public-key');
}

export function subscribePush(subscription: PushSubscriptionJSON) {
  return api<{ message: string }>('/push/subscribe', {
    method: 'POST',
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      keys: subscription.keys,
    }),
  });
}

export function unsubscribePush(endpoint: string) {
  return api<{ message: string }>('/push/subscribe', {
    method: 'DELETE',
    body: JSON.stringify({ endpoint }),
  });
}
